import Axios, { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'

import { ServerErrorType } from '../types/ServerError'

export const useGetErrorText = () => {
  const { t } = useTranslation('PMGeneral')
  const getErrorText = (error: unknown, original = false) => {
    if (Axios.isAxiosError(error)) {
      const serverError = error as AxiosError<ServerErrorType>
      if (serverError && serverError.response?.data) {
        return original
          ? serverError.response.data.message
          : t(`errors.${serverError.response.data.message}`)
      }
    }
  }

  return { getErrorText }
}
